import React from 'lib/react';

import PropTypes from 'prop-types';
import { EVAlert, EVGrid, EVTypography } from 'lib/components';

import WarningBannerStyles from './WarningBannerStyles';

export default function WarningBanner({ heading, body }) {
  const classes = WarningBannerStyles();
  return (
    <EVAlert className={classes.banner} severity="warning">
      <EVGrid container direction="column">
        {heading && (
          <EVTypography className={classes.heading}>
            {heading}
          </EVTypography>
        )}
        {body && (
          <EVTypography className={classes.body}>
            {body}
          </EVTypography>
        )}
      </EVGrid>
    </EVAlert>
  );
}

WarningBanner.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string,
};

WarningBanner.defaultProps = {
  heading: null,
  body: null,
};
